import { merge } from 'lodash';
import { ChartOptions, Options, PlotOptions, TooltipOptions, XAxisOptions } from 'highcharts';

import { getBaseGraphConfig } from 'components/common/Graphs/graphConfigs';
import * as K from 'common/constants';

const CHART: ChartOptions = {
  type: K.SERIES_TYPES.LINE,
  animation: false,
};

const X_AXIS: XAxisOptions = {
  crosshair: {
    width: 1,
  },
  maxPadding: 0,
  minPadding: 0,
  startOnTick: false,
  endOnTick: false,
};

const PLOT_OPTIONS: PlotOptions = {
  series: {
    connectNulls: true,
    marker: {
      enabled: false,
    },
    states: {
      hover: {
        lineWidthPlus: 0,
      },
    },
  },
  column: {
    pointPlacement: 'on',
  },
};

const TOOLTIP: TooltipOptions = {
  useHTML: true,
  followPointer: true,
  enabled: true,
  hideDelay: 0,
  xDateFormat: '%a %b %e, %l:%M:%S %p',
  borderColor: 'transparent',
  footerFormat:
    '<tr><td colspan="3" class="GraphResults__TooltipFooter"><div class="GraphResults__TooltipDateTime">{point.key}</div></td></tr></tbody></table>',
  valueDecimals: 2,
  shared: true,
  outside: true,
};

const CONFIG = {
  chart: CHART,
  xAxis: X_AXIS,
  plotOptions: PLOT_OPTIONS,
  tooltip: TOOLTIP,
};

const getScalyrGraphConfig = (): Options => merge(getBaseGraphConfig(), CONFIG);

export default getScalyrGraphConfig;
